// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconHeadPhone: React.FC<{}> = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="16" viewBox="0 0 11 16">
            <path
                fill="#CD4A23"
                d="M0,2 C0,0.90625 0.90625,0 2,0 L9,0 C10.09375,0 11,0.90625 11,2 L11,14 C11,15.09375 10.09375,16 9,16 L2,16 C0.90625,16 0,15.09375 0,14 L0,2 Z M3.5,13.75 C3.5,14.15625 3.84375,14.5 4.25,14.5 L6.75,14.5 C7.15625,14.5 7.5,14.15625 7.5,13.75 C7.5,13.34375 7.15625,13 6.75,13 L4.25,13 C3.84375,13 3.5,13.34375 3.5,13.75 Z M9,2 L2,2 L2,11.5 L9,11.5 L9,2 Z"
            />
        </svg>
    );
};

export default React.memo(IconHeadPhone);
